import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { isProductionHost } from "../seo/site";
import { pageMetadata } from "../seo/metadata";

export default function useAnalytics() {
    const { pathname } = useLocation();
    useEffect(() => {
        if (!isProductionHost(window.location.hostname) || pathname.startsWith('/client/')) return;
        if (typeof window.gtag !== "undefined") {
            window.gtag("event", "page_view", {
                page_path: pathname,
                page_location: window.location.origin + pathname,
                page_title: pageMetadata(pathname).title,
            });
        }
    }, [pathname]);
}
